import { useState, useEffect, useContext, useRef } from 'react';
import PageContext from '../sub-components/PageContext';
import { useSelector } from 'react-redux';
import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import { styled, Typography } from '@mui/material';
import EditCompanyDetailsModal from '../sub-components/EditCompanyDetailsModal';
import AddSubCompanyModal from '../sub-components/AddSubCompanyModal';
import EditSubCompanyModal from '../sub-components/EditSubCompanyModal';
import OrderedDataTable from '../sub-components/OrderedDataTableCopy.jsx';
import SubCompanyRow from '../sub-components/SubCompanyRow';
import RebateSetupRow from '../sub-components/RebateSetupRow';
import CompanyEntitlementsRow from '../sub-components/CompanyEntitlementsRow';
import EditRebateSetupModal from '../sub-components/EditRebateSetupModal'; 
import AddRebateSetupModal from '../sub-components/AddRebateSetupModal';
import EditCompanyEntitlementsModal from '../sub-components/EditCompanyEntitlementsModal';
import AddCompanyEntitlementsModal from '../sub-components/AddCompanyEntitlementsModal';
import PageTabs from '../sub-components/PageTabsCopy.jsx';
import EditPerformanceBonusModal from '../sub-components/EditPerformanceBonusModal';
import AddPerformanceBonusModal from '../sub-components/AddPerformanceBonusModal';
import { HttpContext } from '../../api-services/HttpService';
import SnackbarAlert from '../sub-components/SnackbarAlert';
import statusFilter from '../functions/statusFilter';
import standardFilter from '../functions/standardFilter'; 
import applyFilters from '../functions/applyFilters';
import PayoutInfoRow from '../sub-components/PayoutInfoRow';
import AddPayoutInfoModal from '../sub-components/AddPayoutInfoModal';
import EditPayoutInfoModal from '../sub-components/EditPayoutInfoModal';
// import EntitledButton from '../sub-components/EntitledButton';
import PageDropdown from '../sub-components/PageDropdownWithIdObjCopy.jsx';
import EditAccountIdsModal from '../sub-components/EditAccountIdsModal'; 
import { AuthContext } from '../../auth/AuthRoute';
import AdditionalDetailsModal from '../sub-components/AdditionalDetailsModal';  
import ViewSubCompaniesModal from '../sub-components/ViewCompaniesModal';
import ConsortiumViewRow from '../sub-components/ConsortiumViewClientInfoRow';
// import ExportS3ExcelButton from '../sub-components/ExportS3ExcelButton'; 
// import UploadS3ExcelButton from '../sub-components/UploadS3ExcelButton';
import ProcessingLogTableRow from '../sub-components/ProcessingLogTableRow'; 
// import BannerAlert from '../sub-components/BannerAlertCopy.jsx';
import ProcessingCommentModal from '../sub-components/ProcessingCommentModal'; 
import UploadContractRow from '../sub-components/UploadContractRow'; 
import AddClientContractModal from '../sub-components/AddClientContractModal'; 
import ContractUploadCommentModal from '../sub-components/ContractUploadCommentModal'; 
import EditUploadClientContractModal from '../sub-components/EditUploadClientContractModal'; 
import getPageTabs from '../functions/getPageTabs';
import PageDropdownBasic from '../sub-components/PageDropdownCopy.jsx'; 
import RebateComponentDisplay from '../sub-components/RebateComponentDisplayCopy.jsx';
import RebateComponentsEditModal from '../sub-components/RebateComponentsEditModal'; 
import MasterCompanyLevelDisplay from '../sub-components/MasterCompanyLevelDisplay.jsx';
import StandardRowFormatted from '../sub-components/StandardRowFormatted.jsx'; 
import PageToggleButtonGroup from '../sub-components/PageToggleButtonGroupCopy.jsx';
import AddRetentionBonusModal from '../sub-components/AddRetentionBonusModal.jsx';
import EditRetentionBonusModal from '../sub-components/EditRetentionBonusModal.jsx';
import ViewClawbacksModal from '../sub-components/ViewClawbacksModal.jsx';
import AddSignOnBonusModal from '../sub-components/AddSignOnBonusModal.jsx';
import EditSignOnBonusModal from '../sub-components/EditSignOnBonusModal.jsx';
import Footer from "../sub-components/Footer.tsx";
import PageBreadcrumbs from '../sub-components/PageBreadcrumbs.jsx'; 
import ButtonComponent from '../sub-components/ButtonComponent.jsx';
import InfoLabel from '../sub-components/InfoLabel.jsx';
import ExportTemplateModal from '../sub-components/ExportTemplateModal.jsx';
import AddExcelTemplateModal from '../sub-components/AddExcelTemplateModal.jsx';
import CopyRebateSetupsModal from '../sub-components/CopyRebateSetupsModal.jsx'; 

//Styled Topography for table name
const TableName = styled(Typography)(({ theme }) => ({
    // background: "#E6F6FA",
    // color: "#3D3D3D",
    background: process.env.REACT_APP_LABEL_COLOR,
    color: `${process.env.REACT_APP_LABEL_TEXT_COLOR} !important`,
    justifyContent: "center",
    fontSize: "14px",
    minHeight: "40px",
    lineHeight: "24px",
    display: "flex",
    alignItems: "center",
    fontFamily:"Roboto medium, Helvetica, Arial, sans-serif"
}));


const CompanyDetailsPage = () => {
    // initialize http context 
    const {
        GET, 
        // PUT, 
    } = useContext(HttpContext);
    // initialize auth context
    const { 
        getAdmin, 
        // getDataTech, 
    } = useContext(AuthContext); 
    // options for page tabs 
    const pageTabs = [
        {tag: 'Company ID List', key: 0, active: true }, 
        {tag: 'Rebate Setup', key: 1, active: true }, 
        {tag: 'Bonuses', key: 2, active: true }, 
        {tag: 'User Entitlements', key: 3, active: true }, 
        {tag: 'Payout Info', key: 4, active: true }, 
        {tag: 'Upload Excel', key: 5, active: process.env.REACT_APP_UPLOAD_EXCEL == '1'}, 
        {tag: 'Upload Contract', key: 6, active: process.env.REACT_APP_UPLOAD_CLIENT_CONTRACTS == '1'}, 
        // {tag: 'Consortium View', key: 7, active: false}, 
    ]; 
    // get global state
    const company = useSelector((state) => state.company);
    const companyInfo = useSelector((state) => state.companyInfo);
    const backPath = useSelector((state) => state.backPath);
    // initialize modal state
    const [editCompanyDetailsModal, setEditCompanyDetailsModal] = useState(false);
    const [editSubCompanyModal, setEditSubCompanyModal] = useState(false);
    const [editSubCompanyRow, setEditSubCompanyRow] = useState({});
    const [addSubCompanyModal, setAddSubCompanyModal] = useState(false);
    const [editRebateSetupModal, setEditRebateSetupModal] = useState(false);
    const [editRebateSetupRow, setEditRebateSetupRow] = useState({});
    const [addRebateSetupModal, setAddRebateSetupModal] = useState(false);
    const [editEntitlementsModal, setEditEntitlementsModal] = useState(false);
    const [editEntitlementsRow, setEditEntitlementsRow] = useState({});
    const [addEntitlementsModal, setAddEntitlementsModal] = useState(false);
    const [editPayoutTypeModal, setEditPayoutTypeModal] = useState(false);
    const [editPerformanceBonusModal, setEditPerformanceBonusModal] = useState(false);
    const [editPerformanceBonusRow, setEditPerformanceBonusRow] = useState({});
    const [addPerformanceBonusModal, setAddPerformanceBonusModal] = useState(false);
    const [editPayoutInfoModal, setEditPayoutInfoModal] = useState(false);
    const [editPayoutInfoRow, setEditPayoutInfoRow] = useState({});
    const [addPayoutInfoModal, setAddPayoutInfoModal] = useState(false);
    const [editAccountIdsModal, setEditAccountIdsModal] = useState(false); 
    // initialize list states for entitlements modal 
    const [roleList, setRoleList] = useState([]);
    const [userList, setUserList] = useState([]);
    // initialize table state
    const [subCompanyDataList, setSubCompanyDataList] = useState([]);
    const [showSubCompanyDataList, setShowSubCompanyDataList] = useState([]);
    const [subCompanyTableHeader, setSubCompanyTableHeader] = useState([]);
    const [rebateSetupDataList, setRebateSetupDataList] = useState([]);
    const [showRebateSetupDataList, setShowRebateSetupDataList] = useState([]);
    const [rebateSetupTableHeader, setRebateSetupTableHeader] = useState([]);
    const [entitlementsDataList, setEntitlementsDataList] = useState([]);
    const [showEntitlementsDataList, setShowEntitlementsDataList] = useState([]); 
    const [entitlementsTableHeader, setEntitlementsTableHeader] = useState([]);
    const [performanceBonusDataList, setPerformanceBonusDataList] = useState([]);
    const [showPerformanceBonusDataList, setShowPerformanceBonusDataList] = useState([]);
    const [performanceBonusTableHeader, setPerformanceBonusTableHeader] = useState([]);
    const [payoutInfoDataList, setPayoutInfoDataList] = useState([]);
    const [payoutInfoTableHeader, setPayoutInfoTableHeader] = useState([]);
    const [uploadContractsDataList, setUploadContractsDataList] = useState([]); 
    const [uploadContractsTableHeader, setUploadContractsTableHeader] = useState([]); 
    const [showUploadContractsDataList, setShowUploadContractsDataList] = useState([]);
    const [showSpinner, setShowSpinner] = useState(false);
    // initialize tab state
    const [tabValue, setTabValue] = useState(0);
    const [tabList, setTabList] = useState([]); 
    // initialize state for top label
    const [rebateFrequency, setRebateFrequency] = useState('');
    const [primaryCCRM, setPrimaryCCRM] = useState('');
    const [portfolio, setPortfolio] = useState('');
    const [masterCompanyId, setMasterCompanyId] = useState('');
    const [masterCompanyData, setMasterCompanyData] = useState({});
    const [masterCompanyHeader, setMasterCompanyHeader] = useState([]); 
    const [rebateFrequencyList, setRebateFrequencyList] = useState([]);
    const [portfolioList, setPortfolioList] = useState([]);
    const [anniversaryMonth, setAnniversaryMonth] = useState('')
    const [monthList, setMonthList] = useState(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']); 
    // initialize snackbar state
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarColor, setSnackbarColor] = useState('info');
    // initialize rebate setup modal state and refs
    const [productList, setProductList] = useState(['--select--']);
    const [billingRateList, setBillingRateList] = useState(['--select--']);
    const [feeCategoryList, setFeeCategoryList] = useState(['--select--']);
    const [subCompanyList, setSubCompanyList] = useState([]);
    const [masterSetupIdsList, setMasterSetupIdsList] = useState([]);
    const [rebateTypeList, setRebateTypeList] = useState(['--select--']);
    const [payoutMethodList, setPayoutMethodList] = useState(['--select--']);
    const [payoutMethodData, setPayoutMethodData] = useState([]); 
    // initialize check box state
    const defaultCheckboxDropdownState = 'Active';
    const [showInactiveSubcompanies, setShowInactiveSubcompanies] = useState(defaultCheckboxDropdownState);
    const [showInactiveSetups, setShowInactiveSetups] = useState(defaultCheckboxDropdownState);
    const [showInactivePerformance, setShowInactivePerformance] = useState(defaultCheckboxDropdownState);
    const [showInactiveEntitlements, setShowInactiveEntitlements] = useState(defaultCheckboxDropdownState); 
    const [showInactiveContractUploads, setShowInactiveContractUploads] = useState(defaultCheckboxDropdownState); 
    const [showInactiveRetentionBonus, setShowInactiveRetentionBonus] = useState(defaultCheckboxDropdownState); 
    const [showInactiveSignOnBonus, setShowInactiveSignOnBonus] = useState(defaultCheckboxDropdownState); 
    // initialize state for triggering filter on data load
    const [triggerFilter, setTriggerFilter] = useState(false);
    // initialize state for boolean to render edit buttons
    const [editButtonBool, setEditButtonBool] = useState(false);
    const [userEntitlementId, setUserEntitlementId] = useState('-1'); 
    // initialize state to filter rebate setup page 
    const [allObj, setAllObj] = useState({label: 'All', id: 'All'}); 
    const [subCompanyFilter, setSubCompanyFilter] = useState('All');
    const [subCompanyFilterList, setSubCompanyFilterList] = useState(['All']);
    const [productFilter, setProductFilter] = useState(allObj); 
    const [productFilterList, setProductFilterList] = useState([allObj]); 
    const [feeCategoryFilter, setFeeCategoryFilter] = useState(allObj); 
    const [feeCategoryFilterList, setFeeCategoryFilterList] = useState([allObj]); 
    const [billingRateFilter, setBillingRateFilter] = useState(allObj); 
    const [billingRateFilterList, setBillingRateFilterList] = useState([allObj]); 
    const [rebateSetupTypeFilter, setRebateSetupTypeFilter] = useState(allObj); 
    const [rebateSetupTypeFilterList, setRebateSetupTypeFilterList] = useState([allObj]); 
    // initialize state for additional details 
    const [additionalDetailsValue, setAdditionalDetailsValue] = useState(0); 
    const [additionalDetailsTableHeader, setAdditionalDetailsTableHeader] = useState([]); 
    const [showAdditionalDetailsModal, setShowAdditionalDetailsModal] = useState(false); 
    const [additionalDetailsRow, setAdditionalDetailsRow] = useState({}); 
    // intialize state for rebate input type 
    const [rebateInputTypeId, setRebateInputTypeId] = useState(); 
    // initialize state for sub company processor list and default data
    const [processorList, setProcessorList] = useState([]); 
    const [processorDefaultData, setProcessorDefaultData] = useState([]); 
    // initialize sub company modal state
    const [editableBillingRate, setEditableBillingRate] = useState(false); 
    const [editableProcessor, setEditableProcessor] = useState(false); 
    // intialize consortium state 
    const [consortiumFlag, setConsortiumFlag] = useState(false); 
    const [consortiumDataList, setConsortiumDataList] = useState([]); 
    const [consortiumTableHeader, setConsortiumTableHeader] = useState([]); 
    const [consortiumId, setConsortiumId] = useState(''); 
    // initialize state for view sub company modal 
    const [viewModal, setViewModal] = useState(false);
    const [viewCompany, setViewCompany] = useState({}); 
    // initialize state for upload excel tab
    const [templateType, setTemplateType] = useState(''); 
    const [templateTypeData, setTemplateTypeData] = useState([]); 
    const [processingLogDataList, setProcessingLogDataList] = useState([]); 
    const [processingLogTableHeader, setProcessingLogTableHeader] = useState([]); 
    const [refreshSpinner, setRefreshSpinner] = useState(false); 
    // initialize state for processing log modal 
    const [showProcessingCommentModal, setShowProcessingCommentModal] = useState(false); 
    const [processingRow, setProcessingRow] = useState({}); 
    // initialize state for export template modal
    const [showExportTemplateModal,setShowExportTemplateModal] = useState(false);
    // initialize state for upload excel template modal
    const [showUploadExcelTemplateModal,setShowUploadExcelTemplateModal] = useState(false);
    // initialize state for client contract modal 
    const [uploadClientContractModal, setUploadClientContractModal] = useState(false);
    const [contractSpinner, setContractSpinner] = useState(false); 
    const [showContractCommentModal, setShowContractCommentModal] = useState(false); 
    const [showEditContractModal, setShowEditContractModal] = useState(false); 
    const [contractUploadRow, setContractUploadRow] = useState({}); 
    // state for true or false 
    const [trueObj, setTrueObj] = useState({label: 'Active', id: "true"}); 
    const [falseObj, setFalseObj] = useState({label: 'Inactive', id: "false"})
    // initialize state for master company level dynamic inputs 
    const [masterCompanyLevelConfig, setMasterCompanyLevelConfig] = useState([]); 
    const [masterCompanyLevelLists, setMasterCompanyLevelLists] = useState({
        incentiveid: [{label: '--select--', id: '--select--'}], 
        incentivefreq: [{label: '--select--', id: '--select--'}], 
        payoutmonth: monthList, 
        primaryccrm: [{label: '--select--', id: '--select--'}]
    });
    // initialize stat for sub company level input configs 
    const [subCompanyLevelConfig, setSubCompanyLevelConfig] = useState([]); 
    const [subCompanyLevelLists, setSubCompanyLevelLists] = useState({
        active: [trueObj, falseObj], 
        billingrateid: [{label: '--select--', id: '--select--'}]
    });
    // initialize state for rebate setup level input configs 
    const [rebateSetupConfig, setRebateSetupConfig] = useState([]); 
    const [rebateSetupLists, setRebateSetupLists] = useState({
        active: [trueObj, falseObj], 
        billingrateid: [{label: '--select--', id: '--select--'}], 
        producttypeid: [{label: '--select--', id: '--select--'}], 
        feecategoryid: [{label: '--select--', id: '--select--'}], 
        rebatesetuptypeid: [{label: '--select--', id: '--select--'}], 
        companyid: ['--select--'], 
        masterincentivesetupid: ['--select--']
    }); 
    // initialize state for payout info configs
    const [payoutInfoConfig, setPayoutInfoConfig] = useState([]); 
    const [payoutInfoLists, setPayoutInfoLists] = useState({
        active: [trueObj, falseObj], 
        payoutmethodid: [{label: '--select--', id: '--select--'}], 
        achaccounttype: [{label: '--select--', id: '--select--'}], 
        companyid: ['--select--'], 
        state: []
    }); 
    // initialize state for performance bonus 
    const [performanceBonusAddConfig, setPerformanceBonusAddConfig] = useState([]); 
    const [performanceBonusEditConfig, setPerformanceBonusEditConfig] = useState([]); 
    const [performanceBonusLists, setPerformanceBonusLists] = useState({
        active: [trueObj, falseObj], 
        companyid: [{label: '--select--', id: '--select--'}]
    }); 
    // initialize state for rebate components 
    const [rebateComponentConfig, setRebateComponentConfig] = useState([]); 
    const [rebateComponentValues, setRebateComponentValues] = useState({}); 
    const [showRebateComponents, setShowRebateComponents] = useState(); 
    // initialize bonus radio button state 
    const [radioKey, setRadioKey] = useState(0); 
    const [radioButtons, setRadioButtons] = useState([
        {tag: 'Performance', key: 0, active: true}, 
        {tag: 'Retention', key: 1, active: true}, 
        {tag: 'Sign On', key: 2, active: true}
    ]);     
    // initialize state for retention bonus
    const [retentionBonusConfig, setRetentionBonusConfig] = useState([]); 
    const [retentionBonusLists, setRetentionBonusLists] = useState({
        active: [trueObj, falseObj], 
        companyid: [{label: '--select--', id: '--select--'}]
    }); 
    const [retentionBonusDataList, setRetentionBonusDataList] = useState([]); 
    const [showRetentionBonusDataList, setShowRetentionBonusDataList] = useState([]); 
    const [retentionBonusTableHeader, setRetentionBonusTableHeader] = useState([]); 
    // initialise state for retention clawbacks 
    const [retentionClawbackConfig, setRetentionClawbackConfig] = useState([]); 
    const [retentionClawbackLists, setRetentionClawbackLists] = useState({
        active: [trueObj, falseObj]
    }); 
    const [retentionClawbackDataList, setRetentionClawbackDataList] = useState([]); 
    const [showRetentionClawbackDataList, setShowRetentionClawbackDataList] = useState([]); 
    const [retentionClawbackTableHeader, setRetentionClawbackTableHeader] = useState([]); 
    // initialize state for retention bonus modals 
    const [addRetentionBonusModal, setAddRetentionBonusModal] = useState(false); 
    const [editRetentionBonusModal, setEditRetentionBonusModal] = useState(false); 
    const [editRetentionBonusRow, setEditRetentionBonusRow] = useState({});
    const [viewClawbackModal, setViewClawbackModal] = useState(false);
    const [viewClawbackIncentiveSetupId, setViewClawbackIncentiveSetupId] = useState(); 
    const [viewClawbackCompanyId, setViewClawbackCompanyId] = useState(); 
    // initialize state for sign on bonus
    const [signOnBonusDataList, setSignOnBonusDataList] = useState([]); 
    const [showSignOnBonusDataList, setShowSignOnBonusDataList] = useState([]); 
    const [signOnBonusTableHeader, setSignOnBonusTableHeader] = useState([]); 
    const [signOnBonusConfig, setSignOnBonusConfig] = useState([]); 
    const [signOnBonusLists, setSignOnBonusLists] = useState({
        active: [trueObj, falseObj], 
        companyid: [{label: '--select--', id: '--select--'}]
    }); 
    // initialize state for sign on bonus clawbacks 
    const [signOnClawbackConfig, setSignOnClawbackConfig] = useState([]); 
    const [signOnClawbackLists, setSignOnClawbackLists] = useState({
        active: [trueObj, falseObj]
    }); 
    const [signOnClawbackDataList, setSignOnClawbackDataList] = useState([]); 
    const [showSignOnClawbackDataList, setShowSignOnClawbackDataList] = useState([]); 
    const [signOnClawbackTableHeader, setSignOnClawbackTableHeader] = useState([]); 
    // initialize state for sign on bonus modals
    const [addSignOnBonusModal, setAddSignOnBonusModal] = useState(false); 
    const [editSignOnBonusModal, setEditSignOnBonusModal] = useState(false); 
    const [editSignOnBonusRow, setEditSignOnBonusRow] = useState({});
    const [viewSignOnClawbackModal, setViewSignOnClawbackModal] = useState(false);
    const [viewSignOnClawbackIncentiveSetupId, setViewSignOnClawbackIncentiveSetupId] = useState();
    const [viewSignOnClawbackCompanyId, setViewSignOnClawbackCompanyId] = useState(); 
    const [enableReset, setEnableReset] = useState(false);
    const [isMenuLoaded, setIsMenuLoaded] = useState(false);
    const [activeTypeList] = useState(['All','Active','Inactive']);
    // initialize state for copy rebate setups modal
    const [showCopyRebateSetupModal, setShowCopyRebateSetupModal] = useState(false); 
    // initialize file reference
    const file = useRef(); 
    const fileInput = useRef();
    // initialize useRef to determine initial render
    const initialRender1 = useRef(true);
    const initialRender2 = useRef(true);
    const initialRender3 = useRef(true);
    const initialRender4 = useRef(true); 
    const initialRender5 = useRef(true); 
    const initialRender6 = useRef(true); 
    const initialRender7 = useRef(true); 
    const initialRender8 = useRef(true); 
    const initialRender9 = useRef(true); 

    // event handler for edit click 
    const onEditRebateComponents = () => {
        // show modal 
        setShowRebateComponents(showRebateComponents => showRebateComponents = true); 
    }

    // event handler for performance bonus edit click
    const onPerformanceBonusEdit = (row) => {
        setEditPerformanceBonusModal(editPerformanceBonusModal => editPerformanceBonusModal = true); 
        setEditPerformanceBonusRow(editPerformanceBonusRow => editPerformanceBonusRow = row); 
    }

    // event handler for retention bonus edit click 
    const onRetentionBonusEdit = (row) => {
        setEditRetentionBonusModal(editRetentionBonusModal => editRetentionBonusModal = true); 
        setEditRetentionBonusRow(editRetentionBonusRow => editRetentionBonusRow = row); 
    }

    const onSignOnBonusEdit = (row) => {
        setEditSignOnBonusModal(editSignOnBonusModal => editSignOnBonusModal = true); 
        setEditSignOnBonusRow(editSignOnBonusRow => editSignOnBonusRow = row);
    }

    // event hanlder for clawback magnify
    const onClawbackViewClick = (row) => {
        setViewClawbackModal(viewClawbackModal => viewClawbackModal = true); 
        setViewClawbackIncentiveSetupId(viewClawbackIncentiveSetupId => viewClawbackIncentiveSetupId = row['incentivesetupid']); 
        setViewClawbackCompanyId(viewClawbackCompanyId => viewClawbackCompanyId = row['companyid']); 
    }

    // event hanlder for clawback magnify
    const onSignOnClawbackViewClick = (row) => {
        setViewSignOnClawbackModal(viewSignOnClawbackModal => viewSignOnClawbackModal = true); 
        setViewSignOnClawbackIncentiveSetupId(viewSignOnClawbackIncentiveSetupId => viewSignOnClawbackIncentiveSetupId = row['incentivesetupid']); 
        setViewSignOnClawbackCompanyId(viewSignOnClawbackCompanyId => viewSignOnClawbackCompanyId = row['companyid']); 
    }

    // event handler for copy rebate setups button click
    const onCopyRebateSetupsClick = (row) => {
        setShowCopyRebateSetupModal(showCopyRebateSetupModal => showCopyRebateSetupModal = true); 
    }

    // function wrapper to pass row component to datatable
    const SubCompanyRowComponent = (row, count, tableHeader,stickyEnabled ) =>{
        return(
            <>
                <SubCompanyRow row={row} count={count} tableHeader={tableHeader} enableEdit={editButtonBool} stickyEnabled={stickyEnabled}/>
            </>
        );  
    }  

    // function wrapper to pass row component to datatable
    const RebateSetupRowComponent = (row, count, tableHeader,stickyEnabled) =>{
        return(
            <>
                <RebateSetupRow row={row} count={count} tableHeader={tableHeader} enableEdit={editButtonBool} stickyEnabled={stickyEnabled} />
            </>
        ); 
    } 

    // function wrapper to pass row component to datatable
    const CompanyEntitlementsRowComponent = (row, count, tableHeader,stickyEnabled) => {
        return(
            <>
                <CompanyEntitlementsRow row={row} count={count} tableHeader={tableHeader} enableEdit={getAdmin()} stickyEnabled={stickyEnabled} />
            </>
        );
    } 

    // function wrapper to pass row component to datatable
    const PerformanceBonusRowComponent = (row, count, tableHeader, stickyEnabled) => {
        return <StandardRowFormatted row={row} count={count} tableHeader={tableHeader} onEditClick={onPerformanceBonusEdit} enableEdit={editButtonBool} stickyEnabled={stickyEnabled}/>;
    }

    // function wrapper 
    const RetentionBonusRowComponent = (row, count, tableHeader,stickyEnabled) => {
        return <StandardRowFormatted row={row} count={count} tableHeader={tableHeader} onEditClick={onRetentionBonusEdit} enableEdit={editButtonBool} onMagnifyClick={onClawbackViewClick} stickyEnabled={stickyEnabled}/>;
    }

    // function wrapper 
    const SignOnBonusRowComponent = (row, count, tableHeader,stickyEnabled) => {
        return <StandardRowFormatted row={row} count={count} tableHeader={tableHeader} onEditClick={onSignOnBonusEdit} enableEdit={editButtonBool} onMagnifyClick={onSignOnClawbackViewClick} stickyEnabled={stickyEnabled}/>;
    }

    // function wrapper to pass row component to datatable
    const PayoutInfoRowComponent = (row, count, tableHeader,stickyEnabled) => {
        return (
            <>
                <PayoutInfoRow row={row} count={count} tableHeader={tableHeader} enableEdit={editButtonBool} stickyEnabled={stickyEnabled} />
            </>
        );
    }

    // function wrapper to pass row component to datatable
    const ConsortiumRowComponent = (row, count, tableHeader, stickyEnabled) =>{
        return(
            <>
                <ConsortiumViewRow row={row} count={count} tableHeader={tableHeader} back={backPath} enableEdit={false} stickyEnabled={stickyEnabled}/>
            </>
        ); 
    } 

    // function wrapper to pass row component to datatable
    const ProcessingRowComponent = (row, count, tableHeader,stickyEnabled) => {
        return (
            <>
                <ProcessingLogTableRow row={row} count={count} tableHeader={tableHeader} stickyEnabled={stickyEnabled}/>
            </>
        );
    }

    // function wrapper to pass row component to datatable 
    const UploadContractRowComponent = (row, count, tableHeader,stickyEnabled) => {
        return (
            <>
                <UploadContractRow row={row} count={count} tableHeader={tableHeader} enableEdit={editButtonBool} stickyEnabled={stickyEnabled}/>
            </>
        );
    }

    // event handler for master company level click 
    const onMasterCompanyEdit = () => {
        setEditCompanyDetailsModal(editCompanyDetailsModal => editCompanyDetailsModal = true); 
    }
    
    // export template event handler 
    const onTemplateExport = () => {
        return new Promise ((resolve, reject) => {
            // make get request to get presigned url
            GET('/data/companyDetailsData/getPresignedUrl', {
                mastercompanyid: companyInfo['mastercompanyid'], 
                filename: templateType['filename'], 
                templatetype: templateType['templatetypeid'], 
                label: templateType['templatetypedescription'], 
            }).then(res => {
                console.log(res); 
                // show alert on success
                resolve(res); 
            }).catch(err => {
                console.log(err); 
                // show alert on error
                snackbarAlert(true, 'Error Retrieving Data.', 'error'); 
                // reject on error
                reject(err); 
            }); 
        }); 
    }

    // function to set snackbar state
    const snackbarAlert = (show, message, color) => {
        setSnackbarMessage(snackbarMessage => snackbarMessage = message);
        setSnackbarColor(snackbarColor => snackbarColor = color);
        setShowSnackbar(showSnackbar => showSnackbar = show);
    }

    // refresh contract upload table
    const refreshContractUpload = () => {
        setContractSpinner(contractSpinner => contractSpinner = true); 
        return new Promise((resolve, reject) => {
            // hide modal for upload client contracts
            setUploadClientContractModal(uploadClientContractModal => uploadClientContractModal = false); 
            // fetch refresh data
            GET( '/data/uploadClientContract', {
                mastercompanyid: companyInfo['mastercompanyid'], 
            }).then(res => {
                // set state for upload contract table 
                setUploadContractsDataList(uploadContractsDataList => uploadContractsDataList = res['data']['UploadContractsData']); 
                setUploadContractsTableHeader(uploadContractsTableHeader => uploadContractsTableHeader = res['data']['UploadContractsCols']); 
                setShowUploadContractsDataList(showUploadContractsDataList => showUploadContractsDataList = res['data']['UploadContractsData']);               
                // stop showing spinner
                setContractSpinner(contractSpinner => contractSpinner = false); 
                // trigger filter
                setTriggerFilter(triggerFilter => triggerFilter = !triggerFilter); 
                resolve(res);
            }).catch(err => {
                // stop showing spinner
                setContractSpinner(contractSpinner => contractSpinner = false); 
                reject(err);
            });
        }); 
    }

    // wrap get funciton for refresh data 
    const refreshData = () => {
        return new Promise ((resolve, reject) => {
            // set modal as false
            setShowUploadExcelTemplateModal(false);
            setRefreshSpinner(refreshSpinner => refreshSpinner = true); 
            GET('/client/companyDetailsData', {
                mastercompanyid: companyInfo['mastercompanyid'], 
            }).then(res => {
                // set state for processing log table 
                setProcessingLogDataList(processingLogDataList => processingLogDataList = res['data']['ProcessingLogData']); 
                setProcessingLogTableHeader(processingLogTableHeader => processingLogTableHeader = res['data']['ProcessingLogCols']);
                // set state for rebate setups table
                setRebateSetupDataList(rebateSetupDataList => rebateSetupDataList = res['data']['RebateSetupData']);
                setRebateSetupTableHeader(rebateSetupTableHeader => rebateSetupTableHeader = res['data']['RebateSetupCols']);
                // set state for rebate components 
                // setRebateComponentConfig(rebateComponentConfig => rebateComponentConfig = res['data']['RebateComponentConfig']); 
                setRebateComponentValues(rebateComponentValues => rebateComponentValues = res['data']['RebateComponentValues']); 
                // set state for user entitlement table 
                setEntitlementsDataList(entitlementsDataList => entitlementsDataList = res['data']['CompanyEntitlementsData']);
                setEntitlementsTableHeader(entitlementsTableHeader => entitlementsTableHeader = res['data']['CompanyEntitlementsCols']);
                // set state for sub companies table 
                setSubCompanyDataList(subCompanyDataList => subCompanyDataList = res['data']['SubCompanyTableData']);
                setSubCompanyTableHeader(subCompanyTableHeader => subCompanyTableHeader = res['data']['SubCompanyTableCols']);
                // trigger filter
                setTriggerFilter(triggerFilter => triggerFilter = !triggerFilter); 
                // hide spinner
                setRefreshSpinner(refreshSpinner => refreshSpinner = false); 
                // resolve
                resolve(res); 
            }).catch(err => {
                // hide spinner
                setRefreshSpinner(refreshSpinner => refreshSpinner = false); 
                // reject
                reject(err); 
            })
        }); 
    }

    // wrap get funciton for refresh data 
    const getRefreshData = () => {
        return new Promise ((resolve, reject) => {
            setShowSpinner(showSpinner => showSpinner = true);
            GET('/client/companyDetailsData', {
                mastercompanyid: companyInfo['mastercompanyid'], 
            }).then(res => {
                // set state for processing log table 
                setProcessingLogDataList(processingLogDataList => processingLogDataList = res['data']['ProcessingLogData']); 
                setProcessingLogTableHeader(processingLogTableHeader => processingLogTableHeader = res['data']['ProcessingLogCols']);
                // set state for rebate setups table
                setRebateSetupDataList(rebateSetupDataList => rebateSetupDataList = res['data']['RebateSetupData']);
                setRebateSetupTableHeader(rebateSetupTableHeader => rebateSetupTableHeader = res['data']['RebateSetupCols']);
                // set state for rebate components 
                // setRebateComponentConfig(rebateComponentConfig => rebateComponentConfig = res['data']['RebateComponentConfig']); 
                setRebateComponentValues(rebateComponentValues => rebateComponentValues = res['data']['RebateComponentValues']); 
                // set state for user entitlement table 
                setEntitlementsDataList(entitlementsDataList => entitlementsDataList = res['data']['CompanyEntitlementsData']);
                setEntitlementsTableHeader(entitlementsTableHeader => entitlementsTableHeader = res['data']['CompanyEntitlementsCols']);
                // set state for sub companies table 
                setSubCompanyDataList(subCompanyDataList => subCompanyDataList = res['data']['SubCompanyTableData']);
                setSubCompanyTableHeader(subCompanyTableHeader => subCompanyTableHeader = res['data']['SubCompanyTableCols']);
                // set state for payout info 
                setPayoutInfoDataList(payoutInfoDataList => payoutInfoDataList = res['data']['PayoutInfoTableData']);
                setPayoutInfoTableHeader(payoutInfoTableHeader => payoutInfoTableHeader = res['data']['PayoutInfoTableCols']);
                // set state for contract upload 
                setUploadContractsDataList(uploadContractsDataList => uploadContractsDataList = res['data']['UploadContractsData']); 
                setUploadContractsTableHeader(uploadContractsTableHeader => uploadContractsTableHeader = res['data']['UploadContractsCols']);  
                // set performance bonus table state
                setPerformanceBonusDataList( performanceBonusDataList => performanceBonusDataList = res['data']['PerformanceBonusTableData']);
                setPerformanceBonusTableHeader( performanceBonusTableHeader => performanceBonusTableHeader = res['data']['PerformanceBonusTableCols']);
                // set retention bonus table state 
                setRetentionBonusDataList(retentionBonusDataList => retentionBonusDataList = res['data']['RetentionBonusData']); 
                setRetentionBonusTableHeader(retentionBonusTableHeader => retentionBonusTableHeader = res['data']['RetentionBonusCols']); 
                // set retention clawback table state 
                setRetentionClawbackDataList(retentionClawbackDataList => retentionClawbackDataList = res['data']['RetentionClawbackData']); 
                setRetentionClawbackTableHeader(retentionClawbackTableHeader => retentionClawbackTableHeader = res['data']['RetentionClawbackCols']); 
                // set sign on bonus table state 
                setSignOnBonusDataList(signOnBonusDataList => signOnBonusDataList = res['data']['SignOnBonusData']); 
                setSignOnBonusTableHeader(signOnBonusTableHeader => signOnBonusTableHeader = res['data']['SignOnBonusCols']); 
                // set state for sign on clawback 
                setSignOnClawbackDataList(signOnClawbackDataList => signOnClawbackDataList = res['data']['SignOnClawbackData']); 
                setSignOnClawbackTableHeader(signOnClawbackTableHeader => signOnClawbackTableHeader = res['data']['SignOnClawbackCols']); 
                // trigger filter
                setTriggerFilter(triggerFilter => triggerFilter = !triggerFilter); 
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false);
                // resolve
                resolve(res); 
            }).catch(err => {
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false);
                // reject
                reject(err); 
            })
        }); 
    }

    // get all data to render on page from data endpoint
    const getCompanyDetailsData = (masterCompanyName) => {
        // show spinner while getting data
        setShowSpinner(showSpinner => showSpinner = true);
        return new Promise ((resolve, reject) => {
            GET('/client/companyDetailsData', {
                mastercompany: masterCompanyName, 
                mastercompanyid: companyInfo['mastercompanyid']
            }).then(res => {
                // set state for top label
                setMasterCompanyData(masterCompanyData => masterCompanyData = res['data']['MasterCompanyData']);
                setMasterCompanyHeader(masterCompanyHeader => masterCompanyHeader = res['data']['MasterCompanyHeader']); 
                setRebateFrequency(rebateFrequency => rebateFrequency = res['data']['MasterCompanyData']['incentivefreq']);
                setPortfolio(portfolio => portfolio = res['data']['MasterCompanyData']['incentivetype']);
                setMasterCompanyId(masterCompanyId => masterCompanyId = res['data']['MasterCompanyData']['mastercompanyid']); 
                setAnniversaryMonth(anniversaryMonth => anniversaryMonth = res['data']['AnniversaryMonth']); 
                if (res['data']['MasterCompanyData']['primaryccrm']){
                    setPrimaryCCRM(primaryCCRM => primaryCCRM = res['data']['MasterCompanyData']['primaryccrm']);
                } 
                else {
                    setPrimaryCCRM(primaryCCRM => primaryCCRM = ''); 
                }
                // set state for EditCompanyDetailsModal
                setPortfolioList(portfolioList => portfolioList = res['data']['RebateTypeList']);
                setRebateFrequencyList(rebateFrequencyList => rebateFrequencyList = res['data']['RebateFrequencyData']);
                setMasterCompanyLevelConfig(masterComapnyLevelConfig => masterComapnyLevelConfig = res['data']['MasterCompanyLevelConfig']); 
                setMasterCompanyLevelLists(masterCompanyLevelLists => masterCompanyLevelLists = {
                    ...masterCompanyLevelLists, 
                    incentiveid: res['data']['RebateTypeList'], 
                    incentivefreq: res['data']['RebateFrequencyData']
                }); 
                // set state for sub companies table 
                setSubCompanyDataList(subCompanyDataList => subCompanyDataList = res['data']['SubCompanyTableData']);
                setShowSubCompanyDataList(showSubCompanyDataList => showSubCompanyDataList = res['data']['SubCompanyTableData']);
                setSubCompanyTableHeader(subCompanyTableHeader => subCompanyTableHeader = res['data']['SubCompanyTableCols']);
                // set state for rebate setups table
                setRebateSetupDataList(rebateSetupDataList => rebateSetupDataList = res['data']['RebateSetupData']);
                setShowRebateSetupDataList(showRebateSetupDataList => showRebateSetupDataList = res['data']['RebateSetupData']);
                setRebateSetupTableHeader(rebateSetupTableHeader => rebateSetupTableHeader = res['data']['RebateSetupCols']);
                // set performance bonus table state
                setPerformanceBonusDataList( performanceBonusDataList => performanceBonusDataList = res['data']['PerformanceBonusTableData']);
                setShowPerformanceBonusDataList ( performanceBonusDataList => performanceBonusDataList = res['data']['PerformanceBonusTableData'] );
                setPerformanceBonusTableHeader( performanceBonusTableHeader => performanceBonusTableHeader = res['data']['PerformanceBonusTableCols']);
                // set state for entitlements table
                setEntitlementsDataList(entitlementsDataList => entitlementsDataList = res['data']['CompanyEntitlementsData']);
                setShowEntitlementsDataList(showEntitlementsDataList => showEntitlementsDataList = res['data']['CompanyEntitlementsData']); 
                setEntitlementsTableHeader(entitlementsTableHeader => entitlementsTableHeader = res['data']['CompanyEntitlementsCols']);
                // set state for entitlements modal 
                setRoleList(roleList => roleList = ['--select--', ...res['data']['UserRoleData']]);
                // set state for rebate setups modal 
                setProductList(productList => productList = ['--select--', ...res['data']['ProductTypeData']]);
                setBillingRateList(billingRateList => billingRateList = ['--select--', ...res['data']['BillingRateData']]);
                setFeeCategoryList(feeCategoryList => feeCategoryList = ['--select--', ...res['data']['FeeCategoryData']]);
                setSubCompanyList(subCompanyList => subCompanyList = res['data']['SubCompanyList']);
                setMasterSetupIdsList(masterSetupIdsList => masterSetupIdsList = res['data']['MasterSetupIdList']);
                setRebateTypeList(rebateTypeList => rebateTypeList = ['--select--', ...res['data']['RebateTypeList']]);
                setPayoutMethodList(payoutMethodList => payoutMethodList = ['--select--', ...res['data']['PayoutMethodList']]);
                // set state for payout method data for validations 
                setPayoutMethodData(payoutMethodData => payoutMethodData = res['data']['PayoutMethodData']); 
                // set state for rebate setups filter dropdown
                setSubCompanyFilterList(subCompanyFilterList => subCompanyFilterList = ['All', ...res['data']['SubCompanyList']]);
                setProductFilterList(productFilterList => productFilterList = [allObj, ...res['data']['ProductTypeData']]);
                setFeeCategoryFilterList(feeCategoryFilterList => feeCategoryFilterList = [allObj, ...res['data']['FeeCategoryData']]);
                setBillingRateFilterList(billingRateFilterList => billingRateFilterList = [allObj, ...res['data']['BillingRateData']]);
                setRebateSetupTypeFilterList(rebateSetupTypeFilterList => rebateSetupTypeFilterList = [allObj, ...res['data']['RebateSetupTypeList']])
                // set state for payout info table
                setPayoutInfoDataList(payoutInfoDataList => payoutInfoDataList = res['data']['PayoutInfoTableData']);
                setPayoutInfoTableHeader(payoutInfoTableHeader => payoutInfoTableHeader = res['data']['PayoutInfoTableCols']);
                // set edit button bool based on user entitlement 
                setEditButtonBool(editButtonBool => editButtonBool = res['data']['UserEntitlement']);
                setUserEntitlementId(userEntitlementId => userEntitlementId = res['data']['UserEntitlementId']);
                // set state for additional details option
                setAdditionalDetailsValue(additionalDetailsValue => additionalDetailsValue = res['data']['AdditionalDetails']); 
                // set state for rebate rate input type id
                setRebateInputTypeId(rebateInputTypeId => rebateInputTypeId = res['data']['RebateInputTypeId']); 
                // set state for processors
                setProcessorList(processorList => processorList = res['data']['ProcessorIdsList']); 
                setProcessorDefaultData(processorDefaultData => processorDefaultData = res['data']['RebateIncentiveData']); 
                setEditableProcessor(editableProcessor => editableProcessor = res['data']['EditableProcessor']); 
                // set editable billing rate
                setEditableBillingRate(editableBillingRate => editableBillingRate = res['data']['EditableBillingRate']); 
                // set consortium id 
                setConsortiumId(consortiumId => consortiumId = res['data']['ConsortiumId']); 
                setConsortiumFlag(consortiumFlag => consortiumFlag = res['data']['ConsortiumFlag']); 
                setConsortiumDataList(consortiumDataList => consortiumDataList = res['data']['ConsortiumDataList']); 
                setConsortiumTableHeader(consortiumTableHeader => consortiumTableHeader = res['data']['ConsortiumCols']); 
                // set tabs depending on consortiumFlag
                if (res['data']['ConsortiumFlag'] == true){ 
                    setTabList(tabList => tabList = getPageTabs(pageTabs, [{tag: 'Consortium View', key: 7, active: true}]));
                }
                else {
                    setTabList(tabList => tabList = getPageTabs(pageTabs));
                    // change tabValue if it is greater than equal to 5 (tabList.length)
                    if(tabValue == 7){
                        setTabValue(tabValue => tabValue = 0); 
                    }
                }
                // set state for excel upload 
                if (res['data']['TemplateTypeData'].length > 0){
                    setTemplateType(templateType => templateType = res['data']['TemplateTypeData'][0]); 
                } 
                setTemplateTypeData(templateTypeData => templateTypeData = res['data']['TemplateTypeData']);
                // set state for processing log table 
                setProcessingLogDataList(processingLogDataList => processingLogDataList = res['data']['ProcessingLogData']); 
                setProcessingLogTableHeader(processingLogTableHeader => processingLogTableHeader = res['data']['ProcessingLogCols']);
                // set state for upload contract table 
                setUploadContractsDataList(uploadContractsDataList => uploadContractsDataList = res['data']['UploadContractsData']); 
                setUploadContractsTableHeader(uploadContractsTableHeader => uploadContractsTableHeader = res['data']['UploadContractsCols']);  
                setShowUploadContractsDataList(showUploadContractsDataList => showUploadContractsDataList = res['data']['UploadContractsData']); 
                // set state for input configs 
                setSubCompanyLevelConfig(subCompanyLevelConfig => subCompanyLevelConfig = res['data']['SubCompanyLevelConfig']); 
                setSubCompanyLevelLists(subCompanyLevelLists => subCompanyLevelLists = { 
                    active: [trueObj, falseObj], 
                    billingrateid: res['data']['BillingRateData']
                }); 
                setRebateSetupConfig(rebateSetupConfig => rebateSetupConfig = res['data']['RebateSetupConfig']); 
                setRebateSetupLists(rebateSetupLists => rebateSetupLists = {
                    active: [trueObj, falseObj], 
                    billingrateid: res['data']['BillingRateData'], 
                    producttypeid: res['data']['ProductTypeData'], 
                    feecategoryid: res['data']['FeeCategoryData'], 
                    rebatesetuptypeid: res['data']['RebateSetupTypeList'], 
                    companyid:  res['data']['SubCompanyList'], 
                    masterincentivesetupid: res['data']['MasterSetupIdList']
                }); 
                setPayoutInfoConfig(payoutInfoConfig => payoutInfoConfig = res['data']['PayoutInfoConfig']); 
                setPayoutInfoLists(payoutInfoLists => payoutInfoLists = {
                    active: [trueObj, falseObj], 
                    payoutmethodid: res['data']['PayoutMethodData'], 
                    achaccounttype: res['data']['AchAccountTypeList'], 
                    companyid: res['data']['SubCompanyList'], 
                    state: res['data']['StateList']
                }); 
                // set statr for performance bonus 
                setPerformanceBonusAddConfig(performanceBonusAddConfig => performanceBonusAddConfig = res['data']['PerformanceBonusAddConfig']); 
                setPerformanceBonusEditConfig(performanceBonusEditConfig => performanceBonusEditConfig = res['data']['PerformanceBonusEditConfig']); 
                setPerformanceBonusLists(performanceBonusLists => performanceBonusLists = {
                    active: [trueObj, falseObj], 
                    companyid: res['data']['SubCompanyList']
                }); 
                // set state for rebate components 
                setRebateComponentConfig(rebateComponentConfig => rebateComponentConfig = res['data']['RebateComponentConfig']); 
                setRebateComponentValues(rebateComponentValues => rebateComponentValues = res['data']['RebateComponentValues']); 
                // set state for retention bonus 
                setRetentionBonusConfig(retentionBonusConfig => retentionBonusConfig = res['data']['RetentionBonusConfig']); 
                setRetentionBonusLists(retentionBonusLists => retentionBonusLists = {
                    active: [trueObj, falseObj], 
                    companyid: res['data']['SubCompanyList']
                }); 
                setRetentionBonusDataList(retentionBonusDataList => retentionBonusDataList = res['data']['RetentionBonusData']); 
                setShowRetentionBonusDataList(showRetentionBonusDataList => showRetentionBonusDataList = res['data']['RetentionBonusData']); 
                setRetentionBonusTableHeader(retentionBonusTableHeader => retentionBonusTableHeader = res['data']['RetentionBonusCols']); 
                // set state for retention clawback 
                setRetentionClawbackConfig(retentionClawbackConfig => retentionClawbackConfig = res['data']['RetentionClawbackConfig']); 
                setRetentionClawbackDataList(retentionClawbackDataList => retentionClawbackDataList = res['data']['RetentionClawbackData']); 
                setShowRetentionClawbackDataList(showRetentionClawbackDataList => showRetentionClawbackDataList = res['data']['RetentionClawbackData']); 
                setRetentionClawbackTableHeader(retentionClawbackTableHeader => retentionClawbackTableHeader = res['data']['RetentionClawbackCols']); 
                // set state for sign on bonus 
                setSignOnBonusConfig(signOnBonusConfig => signOnBonusConfig = res['data']['SignOnBonusConfig']); 
                setSignOnBonusLists(signOnBonusLists => signOnBonusLists = {
                    active: [trueObj, falseObj], 
                    companyid: res['data']['SubCompanyList']
                }); 
                setSignOnBonusDataList(signOnBonusDataList => signOnBonusDataList = res['data']['SignOnBonusData']); 
                setShowSignOnBonusDataList(showSignOnBonusDataList => showSignOnBonusDataList = res['data']['SignOnBonusData']); 
                setSignOnBonusTableHeader(signOnBonusTableHeader => signOnBonusTableHeader = res['data']['SignOnBonusCols']); 
                // set state for sign on clawback 
                setSignOnClawbackConfig(signOnClawbackConfig => signOnClawbackConfig = res['data']['SignOnClawbackConfig']); 
                setSignOnClawbackDataList(signOnClawbackDataList => signOnClawbackDataList = res['data']['SignOnClawbackData']); 
                setShowSignOnClawbackDataList(showSignOnClawbackDataList => showSignOnClawbackDataList = res['data']['SignOnClawbackData']); 
                setSignOnClawbackTableHeader(signOnClawbackTableHeader => signOnClawbackTableHeader = res['data']['SignOnClawbackCols']); 
                // trigger filter
                setTriggerFilter(triggerFilter => triggerFilter = !triggerFilter);
                // stop showing spinner
                setShowSpinner(showSpinner => showSpinner = false);
                resolve(res);
                setIsMenuLoaded(true);
            }).catch(err => {
                // stop showing spinner
                setIsMenuLoaded(false);
                setShowSpinner(showSpinner => showSpinner = false);
                reject(err);
            });
        });
    }

    // get user info from users endpoint
    const getUserInfoData = () => {
        return new Promise((resolve, reject) => {
            GET('/user/inv/headers', {}).then(res => {
                let temp = ['None'];
                // if user is active add to list
                for (let i = 0; i < res['data']['UserInventory']['Users'].length; i++){
                    if (res['data']['UserInventory']['Users'][i]['Enabled'] == true){
                        temp.push(res['data']['UserInventory']['Users'][i]['Username']);
                    }
                }
                // set userlist to render on screen
                setUserList(userList => userList = temp);
                setMasterCompanyLevelLists(masterCompanyLevelLists => masterCompanyLevelLists = {
                    ...masterCompanyLevelLists, 
                    primaryccrm: temp
                }); 
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        });
    }

    useEffect(() => {
        // make initial get request on render
        getCompanyDetailsData(company).then(res => {
            console.log(res);
        }).catch( err => {
            console.log(err);
        });
        // make get request to get user list on render
        getUserInfoData().then(res=> {
            console.log(res);
        }).catch(err => {
            console.log(err);
        });
    }, [companyInfo]);

    // useEffect to filter sub company table for active/inactive
    useEffect(() => {
        // do not run on initial render
        if (!initialRender1.current){
            // set status var from dropdown 
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: statusFilter, value: showInactiveSubcompanies, flag: 1, cols: ['active']}, 
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(subCompanyDataList, functionList);
            // update showDataList
            setShowSubCompanyDataList(showSubCompanyDataList => showSubCompanyDataList = filteredList);
        }
        else{
            initialRender1.current = false;
        }
    }, [showInactiveSubcompanies, triggerFilter]);

    // useEffect to filter rebate setup table 
    useEffect(() => {
        // do not run on initial render
        if (!initialRender2.current){
            // set status var from dropdown 
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: statusFilter, value: showInactiveSetups, flag: 1, cols: ['active']}, 
                {function: standardFilter, value: subCompanyFilter, flag: 1, cols: ['companyid']}, 
                {function: standardFilter, value: productFilter['label'], flag: 1, cols: ['producttypedescription']}, 
                {function: standardFilter, value: feeCategoryFilter['label'], flag: 1, cols: ['feecategorydescription']}, 
                {function: standardFilter, value: billingRateFilter['label'], flag: 1, cols: ['billingratedescription']}, 
                {function: standardFilter, value: rebateSetupTypeFilter['label'], flag: 1, cols: ['rebatesetuptypedescription']}
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(rebateSetupDataList, functionList);
            // update showDataList
            setShowRebateSetupDataList(showRebateSetupDataList => showRebateSetupDataList = filteredList);
        }
        else{
            initialRender2.current = false;
        }
    }, [showInactiveSetups, subCompanyFilter, productFilter, feeCategoryFilter, billingRateFilter, rebateSetupTypeFilter, triggerFilter]);

    // useEffect to filter performance bonus table for active/inactive
    useEffect(() => {
        // do not run on initial render
        if (!initialRender3.current){
            // set status var from dropdown 
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: statusFilter, value: showInactivePerformance, flag: 1, cols: ['active']}, 
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(performanceBonusDataList, functionList);
            // update showDataList
            setShowPerformanceBonusDataList(showPerformanceBonusDataList => showPerformanceBonusDataList = filteredList);
        }
        else {
            initialRender3.current = false;
        }
    }, [showInactivePerformance, triggerFilter]);

    // useEffect to filter entitlements data table
    useEffect(() => {
        if (!initialRender4.current){
            // set status var from dropdown
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: statusFilter, value: showInactiveEntitlements, flag: 1, cols: ['active']}, 
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(entitlementsDataList, functionList);
            // update showDataList
            setShowEntitlementsDataList(showEntitlementsDataList => showEntitlementsDataList = filteredList);
        }
        else {
            initialRender4.current = false; 
        }
    }, [showInactiveEntitlements, triggerFilter]); 

    // useEffect to filter contracts table 
    useEffect(() => {
        if (!initialRender5.current){
            // set status var from dropdown
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: statusFilter, value: showInactiveContractUploads, flag: 1, cols: ['active']}, 
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(uploadContractsDataList, functionList);
            // update showDataList
            setShowUploadContractsDataList(showUploadContractsDataList => showUploadContractsDataList = filteredList);
        }
        else {
            initialRender5.current = false; 
        }
    }, [showInactiveContractUploads, triggerFilter]); 

    // useEffect to filter retention bonus table 
    useEffect(() => {
        if (!initialRender6.current){
            // set status var from dropdown
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: statusFilter, value: showInactiveRetentionBonus, flag: 1, cols: ['active']}, 
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(retentionBonusDataList, functionList);
            // update showDataList
            setShowRetentionBonusDataList(showRetentionBonusDataList => showRetentionBonusDataList = filteredList);
        }
        else {
            initialRender6.current = false; 
        }
    }, [showInactiveRetentionBonus, triggerFilter]); 

    // useEffect to filter retention bonus table 
    useEffect(() => {
        if (!initialRender7.current){
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: standardFilter, value: viewClawbackIncentiveSetupId, flag: 1, cols: ['incentivesetupid']}, 
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(retentionClawbackDataList, functionList);
            // update showDataList
            setShowRetentionClawbackDataList(showRetentionClawbackDataList => showRetentionClawbackDataList = filteredList);
        }
        else {
            initialRender7.current = false; 
        }
    }, [viewClawbackIncentiveSetupId, triggerFilter]); 

    // useEffect to filter sign on bonus table 
    useEffect(() => {
        if (!initialRender8.current){
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: standardFilter, value: viewSignOnClawbackIncentiveSetupId, flag: 1, cols: ['incentivesetupid']}, 
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(signOnClawbackDataList, functionList);
            // update showDataList
            setShowSignOnClawbackDataList(showSignOnClawbackDataList => showSignOnClawbackDataList = filteredList);
        }
        else {
            initialRender8.current = false; 
        }
    }, [viewSignOnClawbackIncentiveSetupId, triggerFilter]); 

    // useEffect to filter retention bonus table 
    useEffect(() => {
        if (!initialRender9.current){
            // set status var from dropdown
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: statusFilter, value: showInactiveSignOnBonus, flag: 1, cols: ['active']}, 
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(signOnBonusDataList, functionList);
            // update showDataList
            setShowSignOnBonusDataList(showSignOnBonusDataList => showSignOnBonusDataList = filteredList);
        }
        else {
            initialRender9.current = false; 
        }
    }, [showInactiveSignOnBonus, triggerFilter]); 

    // use Effect to run on initial render to set tabs
    useEffect(() => {
        setTabList(tabList => tabList = getPageTabs(pageTabs)); 
    }, []); 

    // object with variables to pass to context
    const settings = {
        company, 
        companyInfo, 
        editCompanyDetailsModal, 
        setEditCompanyDetailsModal,
        editSubCompanyModal, 
        setEditSubCompanyModal,
        editSubCompanyRow,
        setEditSubCompanyRow,
        addSubCompanyModal, 
        setAddSubCompanyModal,
        rebateSetupDataList, 
        setRebateSetupDataList, 
        rebateSetupTableHeader, 
        setRebateSetupTableHeader, 
        editRebateSetupModal, 
        setEditRebateSetupModal, 
        editRebateSetupRow, 
        setEditRebateSetupRow,
        addRebateSetupModal, 
        setAddRebateSetupModal,
        editEntitlementsModal, 
        setEditEntitlementsModal, 
        editEntitlementsRow, 
        setEditEntitlementsRow, 
        addEntitlementsModal, 
        setAddEntitlementsModal, 
        roleList, 
        userList, 
        editPayoutTypeModal,
        setEditPayoutTypeModal, 
        editPerformanceBonusModal, 
        setEditPerformanceBonusModal, 
        editPerformanceBonusRow, 
        setEditPerformanceBonusRow, 
        addPerformanceBonusModal, 
        setAddPerformanceBonusModal, 
        masterCompanyData, 
        setMasterCompanyData, 
        rebateFrequencyList,  
        portfolioList,
        getCompanyDetailsData,  
        showSnackbar, 
        setShowSnackbar,
        snackbarMessage, 
        snackbarColor,   
        snackbarAlert,
        productList, 
        billingRateList,
        feeCategoryList, 
        subCompanyList, 
        masterSetupIdsList, 
        rebateTypeList, 
        editPayoutInfoModal, 
        setEditPayoutInfoModal, 
        editPayoutInfoRow, 
        setEditPayoutInfoRow, 
        payoutMethodList,
        addPayoutInfoModal, 
        setAddPayoutInfoModal, 
        editAccountIdsModal, 
        setEditAccountIdsModal, 
        editButtonBool, 
        payoutMethodData, 
        showAdditionalDetailsModal, 
        setShowAdditionalDetailsModal, 
        additionalDetailsTableHeader, 
        additionalDetailsValue, 
        additionalDetailsRow, 
        setAdditionalDetailsRow,
        rebateInputTypeId, 
        processorList, 
        processorDefaultData, 
        portfolio, 
        editableBillingRate, 
        editableProcessor, 
        viewModal, 
        setViewModal, 
        viewCompany, 
        setViewCompany, 
        consortiumFlag, 
        showProcessingCommentModal, 
        setShowProcessingCommentModal,
        processingRow,
        setProcessingRow, 
        showExportTemplateModal,
        setShowExportTemplateModal,
        showUploadExcelTemplateModal,
        setShowUploadExcelTemplateModal,
        refreshData,
        templateType,
        setTemplateType,
        templateTypeData,
        onTemplateExport,
        anniversaryMonth,
        setAnniversaryMonth, 
        monthList, 
        setMonthList,
        uploadClientContractModal, 
        setUploadClientContractModal,
        refreshContractUpload, 
        showContractCommentModal, 
        setShowContractCommentModal,
        showEditContractModal, 
        setShowEditContractModal,  
        contractUploadRow, 
        setContractUploadRow, 
        uploadContractsDataList, 
        masterCompanyLevelConfig, 
        masterCompanyLevelLists, 
        subCompanyLevelConfig, 
        subCompanyLevelLists,
        rebateSetupConfig, 
        rebateSetupLists, 
        payoutInfoConfig, 
        payoutInfoLists, 
        getRefreshData, 
        showSpinner, 
        performanceBonusAddConfig, 
        performanceBonusEditConfig,
        performanceBonusLists, 
        retentionBonusConfig, 
        retentionBonusLists, 
        retentionClawbackConfig, 
        retentionClawbackLists, 
        addRetentionBonusModal, 
        setAddRetentionBonusModal, 
        editRetentionBonusModal, 
        setEditRetentionBonusModal, 
        editRetentionBonusRow, 
        setEditRetentionBonusRow, 
        showRetentionClawbackDataList, 
        setShowRetentionClawbackDataList, 
        retentionClawbackTableHeader, 
        setRetentionClawbackTableHeader,  
        signOnBonusConfig, 
        signOnBonusLists, 
        signOnClawbackConfig, 
        signOnClawbackLists, 
        addSignOnBonusModal, 
        setAddSignOnBonusModal, 
        editSignOnBonusModal, 
        setEditSignOnBonusModal, 
        editSignOnBonusRow, 
        setEditSignOnBonusRow, 
        showSignOnClawbackDataList, 
        setShowSignOnClawbackDataList, 
        signOnClawbackTableHeader, 
        setSignOnClawbackTableHeader, 
        showCopyRebateSetupModal, 
        setShowCopyRebateSetupModal
    };

    //reset functionality 
    const resetToDefault = () => {
        setSubCompanyFilter('All');
        setRebateSetupTypeFilter(allObj);
        setProductFilter(allObj);
        setFeeCategoryFilter(allObj);
        setBillingRateFilter(allObj);
    }

    const enableResetAll = () => {
        if(subCompanyFilter !== 'All' || rebateSetupTypeFilter.label !== 'All' || productFilter.label !== 'All'
            || feeCategoryFilter.label !== 'All' || billingRateFilter.label !== 'All'
        ){
            return true;
        }
        return false;
    }

    useEffect(() => {
        if(isMenuLoaded && enableResetAll()){
            setEnableReset(true);
        } else {
            setEnableReset(false);
        }
    }, [subCompanyFilter, rebateSetupTypeFilter, productFilter, feeCategoryFilter, billingRateFilter, isMenuLoaded])

    return(
        <div class='summary-page'>
            {/* wrap children so they have access to variables in PageContext */}
            <PageContext.Provider value={ settings }>
                {/* header and navslider present on every page */}
                <HeaderBanner />
                {/* breadcrumbs */}
                <div className="pt-1 ms-3">
                    <PageBreadcrumbs />
                </div>
                {/* modal for viewing sub companies. Default is hidden state */}
                <ViewSubCompaniesModal />
                {/* all modals that can be activated. By default they are initialized in hidden state */}
                <EditCompanyDetailsModal />
                <AddSubCompanyModal />
                <EditSubCompanyModal /> 
                <AddRebateSetupModal />  
                <EditRebateSetupModal /> 
                <AddCompanyEntitlementsModal />
                <EditCompanyEntitlementsModal /> 
                <EditPerformanceBonusModal />
                <AddPerformanceBonusModal />
                <AddPayoutInfoModal />
                <EditPayoutInfoModal />
                <EditAccountIdsModal />
                <AdditionalDetailsModal />
                <ProcessingCommentModal />
                <ExportTemplateModal />
                <AddExcelTemplateModal/>
                <AddClientContractModal />
                <ContractUploadCommentModal />
                <EditUploadClientContractModal />
                <RebateComponentsEditModal show={showRebateComponents} setShow={setShowRebateComponents} valuesArg={rebateComponentValues} configArg={rebateComponentConfig} path='/client/rebateComponents' masterCompanyId={masterCompanyData['mastercompanyid']} getRefreshData={getRefreshData} />
                <AddRetentionBonusModal />
                <EditRetentionBonusModal />
                <ViewClawbacksModal 
                    viewClawbackModal={viewClawbackModal} 
                    setViewClawbackModal={setViewClawbackModal} 
                    clawbackTableHeader={retentionClawbackTableHeader} 
                    clawbackDataList={showRetentionClawbackDataList} 
                    clawbackConfig={retentionClawbackConfig} 
                    clawbackLists={retentionClawbackLists} 
                    showSpinner={showSpinner} 
                    editButtonBool={editButtonBool} 
                    snackbarAlert={snackbarAlert}
                    getRefreshData={getRefreshData}
                    masterCompanyData={masterCompanyData}
                    incentiveSetupId={viewClawbackIncentiveSetupId}
                    companyId={viewClawbackCompanyId}
                    description={'retention_clawback'}
                />
                <AddSignOnBonusModal />
                <EditSignOnBonusModal />
                <ViewClawbacksModal 
                    viewClawbackModal={viewSignOnClawbackModal} 
                    setViewClawbackModal={setViewSignOnClawbackModal} 
                    clawbackTableHeader={signOnClawbackTableHeader} 
                    clawbackDataList={showSignOnClawbackDataList} 
                    clawbackConfig={signOnClawbackConfig} 
                    clawbackLists={signOnClawbackLists}
                    showSpinner={showSpinner} 
                    editButtonBool={editButtonBool} 
                    snackbarAlert={snackbarAlert}
                    getRefreshData={getRefreshData}
                    masterCompanyData={masterCompanyData}
                    incentiveSetupId={viewSignOnClawbackIncentiveSetupId}
                    companyId={viewSignOnClawbackCompanyId}
                    description={'sign_on_clawback'}
                />
                <CopyRebateSetupsModal/>
                {/* snackbar component for alerts */}
                <SnackbarAlert />
                <div className="container-fluid d-flex flex-column">
                    <div className="d-flex flex-column flex-grow-1 p-2">
                        {/* top label to view company data */}
                        <div className="mb-2" style={{ borderRadius: "12px", background: "white" }}>
                            <MasterCompanyLevelDisplay values={masterCompanyData} config={masterCompanyHeader} entitled={editButtonBool} isLoading={showSpinner} onClick={onMasterCompanyEdit}/>
                        </div>
                        {/* tabs component for navigation between sections without leaving page */}
                        <div>
                            <PageTabs value={tabValue} setValue={setTabValue} tabList={tabList}/>
                        </div>
                        {/* logic to show different items based on the tab that has been selected */}
                        { tabValue == 0 ?
                        <div className='bg-white p-3 pt-2' style={{borderRadius:"0px 0px 12px 12px"}}>
                            <div className='d-flex align-items-center justify-content-between'>
                                <div className='d-flex gap-3 align-items-center'> 
                                    <PageDropdownBasic alignContent='left' tag='Sub Companies' list={activeTypeList}  value={showInactiveSubcompanies} setValue={setShowInactiveSubcompanies} width={'7rem'} />
                                    <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${showInactiveSubcompanies===defaultCheckboxDropdownState ? '#BDBDBD': '#0295BE'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => showInactiveSubcompanies===defaultCheckboxDropdownState ? null:setShowInactiveSubcompanies(defaultCheckboxDropdownState)}>
                                        Reset All
                                    </div>
                                </div>
                                <div>
                                    {/* <button class='table-add-button' onClick={()=>setAddSubCompanyModal(addSubCompanyModal => addSubCompanyModal = true)}>Add Sub Company</button> */}
                                    {editButtonBool && <ButtonComponent tag='Add Company ID' onButtonClick={()=>setAddSubCompanyModal(addSubCompanyModal => addSubCompanyModal = true)}  border={'#3D3D3D 1px solid'} background={'#3D3D3D'} color={'#FFFFFF'} width='max-content'/>}
                                    {/* <EntitledButton entitledBool={editButtonBool} tag='Add Company ID' cssClass='table-add-button' onClick={()=>setAddSubCompanyModal(addSubCompanyModal => addSubCompanyModal = true)} /> */}
                                </div>
                            </div>
                            <hr className='m-0 mb-2 mt-2'/>
                            <div>
                                <TableName>Company ID List</TableName>
                                <OrderedDataTable varHeight={"450px"} RowComponent={SubCompanyRowComponent} tableHeader={subCompanyTableHeader} dataList={showSubCompanyDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' sortingEnabled={true} stickyFirstColumnEnabled={true}/>
                            </div>
                        </div>
                        : tabValue == 1 ? 
                        <div className='d-flex flex-column gap-2 bg-white p-3 pt-2' style={{borderRadius:"0px 0px 12px 12px"}}>                         
                            <div className='d-flex align-items-center justify-content-between'>
                                {/* <FormControlLabel
                                    value="end"
                                    control={<
                                        sx={{
                                            color: '#000000',
                                            '&.Mui-checked': {
                                            color: '#000000',
                                            },
                                        }} />}
                                    label="Show inactive rebate setups"
                                    labelPlacement="end"
                                    sx={{
                                        color: 'black',
                                    }}
                                    checked={showInactiveSetups}
                                    onChange={(e)=>{setShowInactiveSetups(showInactiveSetups => showInactiveSetups = e.target.checked)}}
                                /> */}
                                <div className='d-flex gap-3 align-items-center'>
                                    <PageDropdownBasic alignContent='left' tag='Rebate Setups' list={activeTypeList}  value={showInactiveSetups} setValue={setShowInactiveSetups} width={'7rem'} />
                                    <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${showInactiveSetups===defaultCheckboxDropdownState ? '#BDBDBD': '#0295BE'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => showInactiveSetups===defaultCheckboxDropdownState ? null:setShowInactiveSetups(defaultCheckboxDropdownState)}>
                                        Reset All
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        {editButtonBool && <ButtonComponent tag='Copy Rebate Setup' onButtonClick={onCopyRebateSetupsClick} border={'#3D3D3D 1px solid'} background={'#fff'} color={'#001317'} width='max-content'/>}
                                        {editButtonBool && <ButtonComponent tag='Add Rebate Setup' onButtonClick={()=>setAddRebateSetupModal(addRebateSetupModal => addRebateSetupModal = true)} border={'#3D3D3D 1px solid'} background={'#3D3D3D'} color={'#FFFFFF'} width='max-content'/>}
                                    </div>
                                    {/* <EntitledButton entitledBool={editButtonBool} tag='Add Rebate Setup' cssClass='table-add-button' onClick={()=>setAddRebateSetupModal(addRebateSetupModal => addRebateSetupModal = true)} />  */}
                                </div>    
                            </div>
                            <hr className='m-0'/>
                            <div>
                                <div className='d-flex gap-3 align-items-center justify-content-start' style={{flexWrap:'wrap'}}>
                                    {/* <div item xs={4} >
                                        <label class='rebate-filter-label'><b>Rebate Setup Filters: </b></label>
                                    </div> */}
                                    <div item xs={4} >
                                        <PageDropdownBasic width = {"8em"} tag='Sub Company: ' value={subCompanyFilter} setValue={setSubCompanyFilter} list={subCompanyFilterList}/>
                                    </div>
                                    <div item xs={4} >
                                        <PageDropdown font= {'14px'} width = {"9em"} tag='Rebate Setup Type: ' obj={rebateSetupTypeFilter} setObj={setRebateSetupTypeFilter} list={rebateSetupTypeFilterList}/>
                                    </div>
                                    <div item xs={4} >
                                        <PageDropdown font= {'14px'} width = {"7em"}tag='Product Type: ' obj={productFilter} setObj={setProductFilter} list={productFilterList}/>
                                    </div>
                                    <div item xs={4} >
                                        <PageDropdown font= {'14px'} width = {"9em"}tag='Fee Category: ' obj={feeCategoryFilter} setObj={setFeeCategoryFilter} list={feeCategoryFilterList} />    
                                    </div>
                                    <div item xs={4} >
                                        <PageDropdown font= {'14px'} width = {"8em"}tag='Billing Rate: ' obj={billingRateFilter} setObj={setBillingRateFilter} list={billingRateFilterList}/>
                                    </div>
                                    <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${enableReset ? '#0295BE': '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => enableReset ? resetToDefault(): null}>
                                        Reset All
                                    </div>
                                </div>
                            </div>   
                            <hr className='m-0'/>    
                            <div>
                                <RebateComponentDisplay tag='Rebate Components:' values={rebateComponentValues} setValues={setRebateComponentValues} config={rebateComponentConfig} portfolioId={masterCompanyData} showOverride={!showSpinner} entitledBool={editButtonBool} onClick={onEditRebateComponents} />
                                <div className='mt-2'>
                                    <TableName>Rebate Setup</TableName>
                                    <OrderedDataTable varHeight={'605px'} RowComponent={RebateSetupRowComponent} tableHeader={rebateSetupTableHeader} dataList={showRebateSetupDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' sortingEnabled={true} stickyFirstColumnEnabled={true}/>
                                </div>
                            </div>
                        </div>
                        : tabValue == 2 ? 
                        <div className='bg-white p-3 pt-2' style={{borderRadius:"0px 0px 12px 12px"}}>
                            <div className='d-flex align-items-center justify-content-between'>
                                <PageToggleButtonGroup alignment={radioKey} setAlignment={setRadioKey} buttonList={radioButtons} />
                                {
                                    radioKey == 2 ?
                                        <div>
                                            {editButtonBool && <ButtonComponent border={'#3D3D3D 1px solid'} background={'#3D3D3D'} color={'#FFFFFF'} tag='Add Sign On Bonus' onButtonClick={()=>setAddSignOnBonusModal(addSignOnBonusModal => addSignOnBonusModal = true)} width='max-content'/> }
                                        </div>
                                    :radioKey == 1 ?
                                        <div>
                                            {editButtonBool && <ButtonComponent border={'#3D3D3D 1px solid'} background={'#3D3D3D'} color={'#FFFFFF'} tag='Add Retention Bonus' onButtonClick={()=>setAddRetentionBonusModal(addRetentionBonusModal => addRetentionBonusModal = true)} width='max-content'/>}
                                        </div>
                                    :radioKey == 0 ?
                                        <div>
                                            {editButtonBool && <ButtonComponent border={'#3D3D3D 1px solid'} background={'#3D3D3D'} color={'#FFFFFF'} tag='Add Bonus Tier' onButtonClick={()=>setAddPerformanceBonusModal(addPerformanceBonusModal => addPerformanceBonusModal = true)} width='max-content'/> }
                                        </div>    
                                    :<></>
                                }
                            </div>
                            <hr className='m-0 mb-2 mt-2'/>
                            { radioKey == 2 ?
                                <>
                                    <div>
                                        <div >
                                            <div className='d-flex mb-2 gap-3 align-items-center'>
                                                <PageDropdownBasic alignContent='left' tag='Sign On Bonus' list={activeTypeList}  value={showInactiveSignOnBonus} setValue={setShowInactiveSignOnBonus} width={'7rem'} />
                                                <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${showInactiveSignOnBonus===defaultCheckboxDropdownState ? '#BDBDBD': '#0295BE'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => showInactiveSignOnBonus===defaultCheckboxDropdownState ? null:setShowInactiveSignOnBonus(defaultCheckboxDropdownState)}>
                                                    Reset All
                                                </div>
                                            </div>
                                        </div>
                                        <TableName>Sign On Bonus</TableName>
                                        <OrderedDataTable varHeight='490px' RowComponent={SignOnBonusRowComponent} tableHeader={signOnBonusTableHeader} dataList={showSignOnBonusDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' sortingEnabled={true} stickyFirstColumnEnabled={true}/>
                                    </div>    
                                </>
                            : radioKey == 1 ? 
                                <div>
                                    <div className='d-flex mb-2 gap-3 align-items-center'>
                                        <PageDropdownBasic alignContent='left' tag='Retention Bonuses' list={activeTypeList}  value={showInactiveRetentionBonus} setValue={setShowInactiveRetentionBonus} width={'7rem'} />
                                        <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${showInactiveRetentionBonus===defaultCheckboxDropdownState ? '#BDBDBD': '#0295BE'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => showInactiveRetentionBonus===defaultCheckboxDropdownState ? null:setShowInactiveRetentionBonus(defaultCheckboxDropdownState)}>
                                            Reset All
                                        </div>
                                    </div>
                                    <TableName>Retention Bonus</TableName>
                                    <OrderedDataTable varHeight='490px' RowComponent={RetentionBonusRowComponent} tableHeader={retentionBonusTableHeader} dataList={showRetentionBonusDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' sortingEnabled={true} stickyFirstColumnEnabled={true}/>
                                </div>     
                            : radioKey == 0 ? 
                                <div>
                                    <div className='d-flex mb-2 gap-3 align-items-center'>
                                        <PageDropdownBasic alignContent='left' tag='Performance Tiers' list={activeTypeList}  value={showInactivePerformance} setValue={setShowInactivePerformance} width={'7rem'} />
                                        <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${showInactivePerformance===defaultCheckboxDropdownState ? '#BDBDBD': '#0295BE'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => showInactivePerformance===defaultCheckboxDropdownState ? null:setShowInactivePerformance(defaultCheckboxDropdownState)}>
                                            Reset All
                                        </div>
                                    </div>
                                    <TableName>Performance Bonus</TableName>
                                    <OrderedDataTable varHeight='490px' RowComponent={PerformanceBonusRowComponent} tableHeader={performanceBonusTableHeader} dataList={showPerformanceBonusDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' sortingEnabled={true} stickyFirstColumnEnabled={true}/>
                                </div>
                            :<></>  }   
                        </div>
                        : tabValue == 3 ? 
                        <div className='bg-white p-3 pt-2' style={{borderRadius:"0px 0px 12px 12px"}}>   
                            <div className='d-flex align-items-center justify-content-between'>
                                <div className='d-flex gap-3 align-items-center'>
                                    <PageDropdownBasic alignContent='left' tag='User Entitlements' list={activeTypeList}  value={showInactiveEntitlements} setValue={setShowInactiveEntitlements} width={'7rem'} />
                                    <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${showInactiveEntitlements===defaultCheckboxDropdownState ? '#BDBDBD': '#0295BE'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => showInactiveEntitlements===defaultCheckboxDropdownState ? null:setShowInactiveEntitlements(defaultCheckboxDropdownState)}>
                                        Reset All
                                    </div>
                                </div>
                                {getAdmin() && <ButtonComponent tag='Add Entitlement' onButtonClick={()=>setAddEntitlementsModal(addEntitlementsModal => addEntitlementsModal = true)}  border={'#3D3D3D 1px solid'} background={'#3D3D3D'} color={'#FFFFFF'} width='max-content'/>}
                                {/* <EntitledButton entitledBool={getAdmin()} tag='Add Entitlement' cssClass='table-add-button' onClick={()=>setAddEntitlementsModal(addEntitlementsModal => addEntitlementsModal = true)}/> */}
                            </div>
                            <hr className='m-0 mb-2 mt-2'/>
                            <div>
                                <TableName>User Entitlements</TableName>
                                <OrderedDataTable varHeight='450px' RowComponent={CompanyEntitlementsRowComponent} tableHeader={entitlementsTableHeader} dataList={showEntitlementsDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' sortingEnabled={true} stickyFirstColumnEnabled={true}/>
                            </div>
                        </div>
                        : tabValue == 4 ?
                        <div className='bg-white p-3 pt-2' style={{borderRadius:"0px 0px 12px 12px"}}>
                            <div className='d-flex justify-content-end'>
                                {editButtonBool && <ButtonComponent tag='Add Payout Info' onButtonClick={()=>setAddPayoutInfoModal(addPayoutInfoModal => addPayoutInfoModal = true)}  border={'#3D3D3D 1px solid'} background={'#3D3D3D'} color={'#FFFFFF'} width='max-content'/>}
                                {/* <EntitledButton entitledBool={editButtonBool} tag='Add Payout Info' cssClass='table-add-button' onClick={()=>setAddPayoutInfoModal(addPayoutInfoModal => addPayoutInfoModal = true)} /> */}
                            </div>
                            {editButtonBool && <hr className='m-0 mb-2 mt-2'/>}
                            <div>
                                <TableName>Payout Info</TableName>
                                <OrderedDataTable varHeight='450px' RowComponent={PayoutInfoRowComponent} tableHeader={payoutInfoTableHeader} dataList={payoutInfoDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' sortingEnabled={true} stickyFirstColumnEnabled={true}/>
                            </div>
                        </div>
                        : tabValue == 5 ? 
                        <div className='bg-white p-3 pt-2' style={{borderRadius:"0px 0px 12px 12px"}}>
                            <div className='d-flex align-items-center justify-content-end'>
                                <ButtonComponent tag='Export Template' border={'#3D3D3D 1px solid'} background={'#fff'} color={'#3D3D3D'} width='10em' onButtonClick={()=>{setShowExportTemplateModal(true)}}/>
                                {/* Only show upload if user is entitled */}
                                { editButtonBool ?
                                    <ButtonComponent tag='Upload Excel' border={'#3D3D3D 1px solid'} background={'#fff'} color={'#3D3D3D'} width='8em' onButtonClick={()=>{setShowUploadExcelTemplateModal(true)}}/>
                                :<></>}
                                <ButtonComponent tag='Refresh Log' border={'#3D3D3D 1px solid'} background={'#fff'} color={'#3D3D3D'} width='8em' onButtonClick={()=>{refreshData()}}/>
                            </div>
                            <hr className='m-0 mb-2 mt-2'/>
                            <TableName >Excel Upload Log</TableName>
                            <OrderedDataTable varHeight={"450px"} RowComponent={ProcessingRowComponent} tableHeader={processingLogTableHeader} dataList={processingLogDataList} showSpinner={showSpinner || refreshSpinner} numToPage={25} skeletonHeight='28vh' sortingEnabled={true} stickyFirstColumnEnabled={true}/>
                        </div>
                        : tabValue == 6 ? 
                        <div className='bg-white p-3 pt-2' style={{borderRadius:"0px 0px 12px 12px"}}>
                            <div className='d-flex align-items-center justify-content-between'>
                                <div className='d-flex gap-3 align-items-center'>
                                    <PageDropdownBasic alignContent='left' tag='Contract Uploads' list={activeTypeList}  value={showInactiveContractUploads} setValue={setShowInactiveContractUploads} width={'7rem'} />
                                    <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${showInactiveContractUploads===defaultCheckboxDropdownState ? '#BDBDBD': '#0295BE'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => showInactiveContractUploads===defaultCheckboxDropdownState ? null:setShowInactiveContractUploads(defaultCheckboxDropdownState)}>
                                        Reset All
                                    </div>
                                </div>
                                {editButtonBool && <ButtonComponent tag='Add Client Contract' onButtonClick={() => {setUploadClientContractModal(uploadClientContractModal => uploadClientContractModal = true)}}  border={'#3D3D3D 1px solid'} background={'#3D3D3D'} color={'#FFFFFF'} width='max-content'/>}
                                {/* <EntitledButton entitledBool={editButtonBool} tag='Add Client Contract' cssClass='table-add-button' onClick={() => {setUploadClientContractModal(uploadClientContractModal => uploadClientContractModal = true)}} /> */}
                            </div>
                            <hr className='m-0 mb-2 mt-2'/>
                            <div>
                                <TableName>Upload Client Contracts</TableName>
                                <OrderedDataTable varHeight='450px' RowComponent={UploadContractRowComponent} tableHeader={uploadContractsTableHeader} dataList={showUploadContractsDataList} showSpinner={showSpinner || contractSpinner} numToPage={25} skeletonHeight='28vh' sortingEnabled={true} stickyFirstColumnEnabled={true}/>
                            </div>
                        </div>
                        : tabValue == 7 ? 
                        <div className='bg-white p-3 pt-2' style={{borderRadius:"0px 0px 12px 12px"}}>
                            <div>
                                <InfoLabel title='Consortium ID:' content={consortiumId}/>
                            </div>
                            <hr className='m-0 mb-2 mt-2'/>
                            <div>
                                <TableName>Consortium View</TableName>
                                <OrderedDataTable varHeight='440px' RowComponent={ConsortiumRowComponent} tableHeader={consortiumTableHeader} dataList={consortiumDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' sortingEnabled={true} stickyFirstColumnEnabled={true}/>
                            </div>
                        </div>
                        :<></>} 
                    </div>
                </div>
                <Footer cssClassName="footer-main-comp"/>
            </PageContext.Provider>
        </div> 
    );
}

export default CompanyDetailsPage;